module.exports = __webpack_public_path__ + "img/cccd-logo.49741310.jpg";